module.exports = __webpack_public_path__ + "static/img/craft_perfect_offer_title_1200x628-01.b94077e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/craft_perfect_offer_title_1200x628-01.png
// module id = MqtT
// module chunks = 1